<template>
  <q-page padding class="balance-report">
    <header class="balance-report__header row items-center justify-between q-mb-md">
      <div><h1>{{ $t('reportCatalog.builtins.balance-report.title') }}</h1>
      <p class="text-grey-7 q-mb-none">{{ t('current') }}</p></div>
      <q-btn color="primary" icon="refresh" :label="t('refresh')" :loading="loading" @click="load()" />
    </header>
    <q-banner v-if="error" class="bg-red-1 text-negative q-mb-md" role="alert">{{ t('error') }}</q-banner>
    <q-tabs v-model="tab" align="left" active-color="primary"><q-tab name="current" :label="$t('reportParity.current')" no-caps /><q-tab name="ledger" :label="$t('reportParity.ledger')" no-caps /></q-tabs>
    <balance-history v-if="tab === 'ledger'" :account="selectedAccount" />
    <q-table v-if="tab === 'current'" @row-click="openHistory" flat bordered :rows="rows" :columns="columns" row-key="id" :loading="loading" v-model:pagination="pagination"
      :rows-per-page-options="[25,50,100]" :no-data-label="t('empty')" :rows-per-page-label="$t('Rows per page')" @request="load" />
  </q-page>
</template>
<script>
import BalanceHistory from '../../components/reports/BalanceHistory.vue';
import { accountsService } from '../../services/requests/accounts.service';
export default {
  name: 'BalanceReport', components: { BalanceHistory },
  data() { return { tab: 'current', selectedAccount: '', rows: [], loading: false, error: false, requestId: 0, pagination: { page: 1, rowsPerPage: 25, rowsNumber: 0 } }; },
  computed: {
    columns() {
      return [
        { name: 'id', field: 'id', label: 'ID', align: 'left' },
        { name: 'name', field: 'name', label: this.t('name'), align: 'left' },
        { name: 'owner', field: r => r._embedded?.owner?.name || '—', label: this.t('owner'), align: 'left' },
        { name: 'balance', field: 'balance', label: this.t('balance'), align: 'right', format: v => v == null ? this.t('unavailable') : Number(v).toLocaleString(this.$i18n.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        { name: 'currency', field: r => r._embedded?.currency?.code || r._embedded?.currency?.name || r._embedded?.currency?.symbol || '—', label: this.t('currency'), align: 'left' },
      ];
    },
  },
  mounted() { this.load(); },
  beforeUnmount() { this.requestId++; },
  methods: {
    openHistory(event, row) { this.selectedAccount = row.id; this.tab = 'ledger'; },
    t(key) { return this.$t(`financeReports.${key}`); },
    async load(request) {
      const pagination = request?.pagination || this.pagination;
      const id = ++this.requestId; this.loading = true; this.error = false;
      try {
        const result = await accountsService.getAll({ page: pagination.page, per_page: pagination.rowsPerPage, forceReload: true,
          'order-by': [{ type: 'field', field: 'id', direction: 'asc' }] });
        if (id !== this.requestId) return;
        this.rows = result.items;
        this.pagination = { ...pagination, rowsNumber: Number(result.totalItems) || 0 };
      } catch { if (id === this.requestId) { this.rows = []; this.error = true; } }
      finally { if (id === this.requestId) this.loading = false; }
    },
  },
};
</script>
<style scoped>
.balance-report { max-width: 1600px; margin: auto; }
h1 { font-size: 24px; line-height: 1.4; font-weight: 500; margin: 8px 0 12px; }
</style>

<style scoped>
.balance-report :deep(.q-card),
.balance-report :deep(.q-table__container),
.balance-report :deep(.q-field__control),
.balance-report :deep(.q-btn),
.balance-report :deep(.q-banner) { border-radius: 0; }
</style>

<style scoped>
.balance-report__header { gap: 16px; }
</style>
